import {useState} from 'react';
import axios from 'axios';

const useFetchTokenLiveKit = () => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  /**
   * Fetch a LiveKit token.
   *
   * IMPORTANT: This function is intentionally **non-throwing**. It returns `null`
   * on failure and sets `error` state instead.
   *
   * Reason: historically, callers didn't consistently `.catch()` token fetch
   * failures, which can surface as disruptive overlays/unhandled promise
   * rejections in the web app when the token service is down.
   */
  const getToken = async ({
    teacherName,
    courseName,
    voice_id,
    courseId,
    userId,
    lessonId,
    session_id,
    lastQuestion,
  }) => {
    setLoading(true);
    try {
      const response = await axios.post(
        'https://livekit-token.quiklearn.ai/get_token',
        {
          instructor: teacherName,
          course: courseName,
          metadata: JSON.stringify({
            voice_id: voice_id,
            institution: 'quiklearn',
            courseId,
            userId,
            // Send both keys for compatibility across backend versions.
            lessonId: lessonId ?? null,
            lesson_id: lessonId ?? null,
            session_id: session_id,
            last_question: lastQuestion,
          }),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const nextToken = response?.data?.token || null;
      setToken(nextToken);
      setError(null);
      return nextToken;
    } catch (err) {
      console.error('getToken', err);
      setError(err?.message || 'An error occurred');
      setToken(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const clearToken = () => {
    setToken(null);
    setError(null);
  };

  return {token, error, loading, getToken, clearToken};
};

export default useFetchTokenLiveKit;
